import { PDFRaster } from "@nova/protobuf"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux/rootReducer"
import { memoize } from "nodash"
import { selectAllEntitiesMap } from "panels/content/side-panel/slice"
import { getAncestors } from "panels/content/side-panel/utils"
import { selectLocalRastersMap } from "plugins/PDFRaster/PDFRasterSlice"

const selectPDFRasters = (s: RootState) => s.project.data.PDFRasters as PDFRaster[]

export const selectAllRasters = createSelector(
    [selectPDFRasters, selectLocalRastersMap()],
    (storedRasters, localRasters) => storedRasters.filter((raster) => !!localRasters[raster.id])
)

export const selectVisibleRasters = createSelector(
    [selectAllRasters, selectLocalRastersMap(), selectAllEntitiesMap],
    (rasters, localRasters, entityMap) =>
        rasters.filter(
            (raster) =>
                localRasters[raster.id].visible &&
                !getAncestors(raster.id, entityMap).find((ancestor) => !ancestor.visible) &&
                !raster.archivedTimestamp
        )
)

export const selectRastersMap = createSelector([selectAllRasters], (rasters) => {
    return rasters.reduce(
        (acc, cur) => {
            acc[cur.id] = cur
            return acc
        },
        {} as Record<string, PDFRaster>
    )
})

export const selectRasterById = memoize((id: string) =>
    createSelector([selectRastersMap], (rasters) => {
        return rasters[id]
    })
)

export const selectRasterByIdWithLocalContext = memoize((id: string) =>
    createSelector([selectRastersMap, selectLocalRastersMap()], (rastersMap, localRastersMap) => {
        return {
            ...rastersMap[id],
            ...localRastersMap[id],
        }
    })
)
